import * as React from 'react';

import { ETenant } from '../../../../../../../json_query';
import { getArrayChange } from '../../../../../../../utils/arrayChange';
import { DropdownField } from '../../../components/dropdownField';

export interface ITenantsProps {
  value: ETenant[];
  onChange(tenant: ETenant, value: boolean): void;
}

export const Tenants: React.StatelessComponent<ITenantsProps> = ({ value, onChange }) => (
  <DropdownField
    multiple
    placeholder="Неважно"
    value={value.concat()}
    onValueChange={(tenants: ETenant[]) => onChange(...getArrayChange(value, tenants))}
    values={[
      { value: ETenant.Any, label: 'Любой' },
      { value: ETenant.Family, label: 'Только для семьи' },
      { value: ETenant.Man, label: 'Только для мужчин' },
      { value: ETenant.Woman, label: 'Только для женщин' },
    ]}
  />
);
